import { render, staticRenderFns } from "./LevelOne.vue?vue&type=template&id=60569f07&scoped=true"
import script from "./LevelOne.vue?vue&type=script&lang=js"
export * from "./LevelOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60569f07",
  null
  
)

export default component.exports